import brand from '../brand.generated.json';
import type { T } from '../i18n';

const telHref = (phone: string) => `tel:${phone.replace(/[^\d+]/g, '')}`;

function Help({ t }: { t: T }) {
  const b = brand as typeof brand & { supportPhone?: string };
  return (
    <p className="landing-help">
      {t('landingHelp')}{' '}
      <a href={`mailto:${b.supportEmail}`}>{b.supportEmail}</a>
      {b.supportPhone && (
        <>
          {' · '}
          <a href={telHref(b.supportPhone)}>{b.supportPhone}</a>
        </>
      )}
    </p>
  );
}

function Mark() {
  return (
    <div className="landing-mark">
      <img src="/favicon.svg" alt="" width={56} height={56} />
      <div>
        <strong>{brand.orderAppName}</strong>
        <span>{brand.tagline}</span>
      </div>
    </div>
  );
}

/** Bare ordering domain (no table context): explain how to order. Never an error, never a tenant list. */
export function Landing({ t }: { t: T }) {
  return (
    <main className="landing" data-testid="order-landing">
      <Mark />
      <h1>{t('landingTitle')}</h1>
      <p className="landing-lead">{t('landingLead')}</p>
      <ol className="landing-steps">
        <li>{t('landingStep1')}</li>
        <li>{t('landingStep2')}</li>
        <li>{t('landingStep3')}</li>
      </ol>
      {brand.urls.website && (
        <p>
          <a className="btn secondary landing-link" href={brand.urls.website}>{t('landingWebsite')}</a>
        </p>
      )}
      <Help t={t} />
    </main>
  );
}

/** A table code that is malformed, replaced or retired: recovery steps without internal detail. */
export function InvalidTable({ t }: { t: T }) {
  return (
    <main className="landing" data-testid="order-invalid">
      <Mark />
      <h1>{t('invalidTitle')}</h1>
      <p className="landing-lead">{t('invalidTable')}</p>
      <ol className="landing-steps">
        <li>{t('invalidStep1')}</li>
        <li>{t('invalidStep2')}</li>
      </ol>
      <Help t={t} />
    </main>
  );
}
